/**
 * Helpers for the studio "notify these mailboxes about a new reservation"
 * setting.
 *
 * The API keeps the addresses in a single comma-separated string
 * (StudioSettings.ReservationNotificationEmail), the same CSV-in-a-column
 * pattern the studio URLs use. The form works with a plain string[] so each
 * row gets its own input and its own validation message, and these two helpers
 * are the only place the two shapes meet.
 */

/** Must stay in sync with EmailRecipientsUtility.MaxRecipients (backend). */
export const MAX_RESERVATION_NOTIFICATION_EMAILS = 20;

const SEPARATOR = ",";

/** API CSV string -> form array. */
export const splitNotificationEmails = (value?: string | null): string[] => {
  if (!value) return [];

  return value
    .split(SEPARATOR)
    .map((email) => email.trim())
    .filter((email) => email.length > 0);
};

/** Form array -> API CSV string, dropping rows the user left blank. */
export const joinNotificationEmails = (emails?: (string | null)[]): string =>
  (emails ?? [])
    .map((email) => (email ?? "").trim())
    .filter((email) => email.length > 0)
    .join(SEPARATOR);
